import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CryptoState } from "../CryptoContext";
import { SingleCoin } from "../config/api";
import { LinearProgress, Typography, makeStyles ,Button} from "@material-ui/core";
import Coininfo from "../components/Coininfo";
import axios from "axios";
import ReactHtmlParser from "react-html-parser";
import { numberWithCommas } from "../components/Carousel";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      aligItems: "center",
    },
  },
  sidebar: {
    width: "30%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: 25,
    borderRight: "2px solid grey",
  },
  heading: {
    fontWeight: "bold",
    marginBottom: 20,
    fontFamily: "Montserrat",
  },
  description: {
    width: "100%",
    fontFamily: "Montserrat",
    padding: 25,
    paddingBottom: 15,
    paddingTop: 0,
    textAlign: "justify",
  },
  marketData: {
    alignSelf: "start",
    padding: 25,
    paddingTop: 10,
    width: "100%",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      justifyContent: "space-around",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "center",
    },
    [theme.breakpoints.down("xs")]: {
      alignItems: "start",
    },
  },
}));

function Coinpage() {
  const { id } = useParams();
  const [coin, setCoin] = useState();

  const { currency, symbol ,user,watchlist,setAlert} = CryptoState();

  const fetchCoin = async () => {
    const { data } = await axios.get(SingleCoin(id));
    setCoin(data);
  };

  useEffect(() => {
    fetchCoin();
  }, []);

  const classes = useStyles();

  const inWatchlist = watchlist.includes(coin?.id)

  const addToWatchlist = async()=>{
    const coinRef = doc(db,"watchlist",user.uid);//reference to the table in database

    try{
      await setDoc(coinRef,{coins:watchlist?[...watchlist,coin?.id]:[coin?.id]})// setting data to the databse table
      setAlert({
        open:true,
        message:`${coin.name} Added to the watchlist !`,
        type:"success"
      })
    }catch(err){
      setAlert({
        open:true,
        message:err.message,
        type:"error"
      })
    }
  }

  const removeFromWatchlist = async ()=>{
    const coinRef = doc(db,"watchlist",user.uid);//reference to the table

    try{
      await setDoc(
        coinRef,
        {
          coins:watchlist.filter((watch)=>watch !== coin?.id)
        },
        {merge:"true"}
      );
      setAlert({
        open:true,
        message:`${coin.name} Removed from the watchlist !`,
        type:"success"
      })
    }catch(err){
      setAlert({
        open:true,
        message:err.message,
        type:"error"
      })
    }
  }

  if (!coin) return <LinearProgress style={{ backgroundColor: "#e64072" }} />;

  return (
    <div className={classes.container}>
      <div className={classes.sidebar}>
        <img
          src={coin?.image.large}
          alt={coin?.name}
          height="200"
          style={{ marginBottom: 20 }}
        />
        <Typography variant="h3" className={classes.heading}>
          {coin?.name}
        </Typography>
        <Typography variant="subtitle1" className={classes.description}>
          {ReactHtmlParser(coin?.description.en.split(". ")[0])}.
        </Typography>
        <div className={classes.marketData}>
          <span style={{ display: "flex" }} className={classes.heading}>
            <Typography variant="h5">Rank:</Typography>
            &nbsp; &nbsp;
            <Typography variant="h5" style={{ fontFamily: "Montserrat" }}>
              {numberWithCommas(coin?.market_cap_rank)}
            </Typography>
          </span>

          <span style={{ display: "flex" }} className={classes.heading}>
            <Typography variant="h5">Current Price :</Typography>
            &nbsp; &nbsp;
            <Typography variant="h5" style={{ fontFamily: "Montserrat" }}>
              {symbol}{" "}
              {numberWithCommas(
                coin?.market_data.current_price[currency.toLowerCase()]
              )}
            </Typography>
          </span>

          <span style={{ display: "flex" }} className={classes.heading}>
            <Typography variant="h5">Market Cap: </Typography>
            &nbsp; &nbsp;
            <Typography variant="h5" style={{ fontFamily: "Montserrat" }}>
              {symbol}{" "}
              {numberWithCommas(
                coin?.market_data.market_cap[currency.toLowerCase()]
                  .toString()
                  .slice(0, -6)
              )}
              M
            </Typography>
          </span>
          {user && (
            <Button 
              variant="outlined"
              style={{
                width:"100%",
                height:40,
                backgroundColor: inWatchlist?"#ff0000" : "#e64072",
                color:"white"
              }}
              onClick={inWatchlist?removeFromWatchlist:addToWatchlist}
            >
              {inWatchlist? "Remove from Watchlist":"Add to Watchlist"}
            </Button>
          )}
        </div>
      </div>
      <Coininfo coin={coin} />
    </div>
  );
}

export default Coinpage;
